import { render } from "./reportedProblems.vue?vue&type=template&id=61caf3ad"
import script from "./reportedProblems.vue?vue&type=script&lang=js"
export * from "./reportedProblems.vue?vue&type=script&lang=js"

import "./reportedProblems.vue?vue&type=style&index=0&id=61caf3ad&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__